angular
	.module 'App.Repository'
	.factory 'UserRepository', ['BaseRepository', (BaseRepository) ->
		class UserRepository extends BaseRepository
			@resource = '/users'
			@isRestricted = true

			findByQuery: (query = null) ->
				if _.isEmpty(query)
					query = @createQuery()

				if !query.isSorted()
					query.sortBy 'full_name', 'ASC'

				super query

			update: (id, model) ->
				delete model["master_user_identifier"]
				delete model["merchant_group"]

				super id, model

		return new UserRepository
	]
